import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCInputModule } from '@wlp/ui-c-input';
import { UiCHeaderOnboardingModule } from '@wlp/ui-c-header-onboarding';

let UiCAccountFormComponent = class UiCAccountFormComponent {
    constructor() {
        this.isBack = true;
        this.isPF = true;
        this.isFirtsacess = true;
        this.back = new EventEmitter();
        this.continue = new EventEmitter();
        this.onCheckCpf = new EventEmitter();
    }
    goBack() {
        this.back.emit();
    }
    goContinue() {
        if (this.form.valid) {
            this.continue.emit();
        }
    }
    onCpfBlur(data) {
        this.onCheckCpf.emit(data);
    }
};
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAccountFormComponent.prototype, "isBack", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCAccountFormComponent.prototype, "form", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCAccountFormComponent.prototype, "errorMessages", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAccountFormComponent.prototype, "block", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountFormComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountFormComponent.prototype, "description", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountFormComponent.prototype, "primaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCAccountFormComponent.prototype, "secondaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAccountFormComponent.prototype, "isPF", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCAccountFormComponent.prototype, "isFirtsacess", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAccountFormComponent.prototype, "back", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAccountFormComponent.prototype, "continue", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCAccountFormComponent.prototype, "onCheckCpf", void 0);
UiCAccountFormComponent = __decorate([
    Component({
        selector: 'ui-c-account-form',
        template: "<div class=\"animation-type\">\n\n  <ui-c-header-onboarding [isBack]=\"isBack\" [textBack]=\"'ONBORDING.V2.BUTTON.BACK' | wlpTranslate\" [title]=\"title\"\n    [description]=\"description\" [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\" (back)=\"goBack()\">\n  </ui-c-header-onboarding>\n\n  <ion-row class=\"ion-justify-content-left ion-align-items-center\">\n    <ng-container *ngIf=\"!isPF\">\n      <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n        <ui-c-input (onBlur)=\"onCpfBlur($event)\" [form]=\"form\" [errorMessages]=\"errorMessages\" [formName]=\"'document'\"\n          data-cy=\"onboarding-pj-document\" [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.CNPJ' | wlpTranslate\"\n          [name]=\"'ONBORDING.V2.FORM.LABEL.CNPJ' | wlpTranslate\" [isCNPJ]=\"true\" [minlength]=\"18\">\n        </ui-c-input>\n      </ion-col>\n      <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n        <ui-c-input [form]=\"form\" [errorMessages]=\"errorMessages\" [formName]=\"'name'\" data-cy=\"onboarding-pj-name\"\n          [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.MY_COMPANY' | wlpTranslate\"\n          [name]=\"'ONBORDING.V2.FORM.LABEL.MY_COMPANY' | wlpTranslate\" [block]=\"block\" [maxlength]=\"'200'\">\n        </ui-c-input>\n      </ion-col>\n    </ng-container>\n\n    <ng-container *ngIf=\"isPF\">\n      <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n        <ui-c-input (onBlur)=\"onCpfBlur($event)\" [form]=\"form\" [errorMessages]=\"errorMessages\" [formName]=\"'document'\"\n          data-cy=\"onboarding-pf-document\" [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.CPF' | wlpTranslate\"\n          [name]=\"'ONBORDING.V2.FORM.LABEL.CPF' | wlpTranslate\" [isCPF]=\"true\" [minlength]=\"14\">\n        </ui-c-input>\n      </ion-col>\n      <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n        <ui-c-input [form]=\"form\" [errorMessages]=\"errorMessages\" [formName]=\"'name'\" data-cy=\"onboarding-pf-name\"\n          [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.MY_NAME' | wlpTranslate\"\n          [name]=\"'ONBORDING.V2.FORM.LABEL.NAME' | wlpTranslate\" [block]=\"block\" [maxlength]=\"'200'\">\n        </ui-c-input>\n      </ion-col>\n    </ng-container>\n\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <ui-c-input [form]=\"form\" [errorMessages]=\"errorMessages\" [formName]=\"'email'\" data-cy=\"onboarding-email\"\n        [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.EMAIL' | wlpTranslate\"\n        [name]=\"'ONBORDING.V2.FORM.LABEL.EMAIL' | wlpTranslate\" [block]=\"block\" [maxlength]=\"'100'\">\n      </ui-c-input>\n    </ion-col>\n\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <ui-c-input [form]=\"form\" [errorMessages]=\"errorMessages\" [formName]=\"'phone'\" data-cy=\"onboarding-phone\"\n        [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.PHONE' | wlpTranslate\"\n        [name]=\"'ONBORDING.V2.FORM.LABEL.PHONE' | wlpTranslate\" [isPhone]=\"isFirtsacess ? true : false \"\n        [maxlength]=\"'15'\" [type]=\"isFirtsacess ? 'tel' : 'text'\" [block]=\"block\">\n      </ui-c-input>\n    </ion-col>\n  </ion-row>\n\n  <ion-row class=\"ion-justify-content-left ion-margin-top ion-margin-bottom\">\n    <ion-col [size]=\"12\" [sizeMd]=\"4\" [sizeSm]=\"4\">\n      <ui-c-button data-cy=\"onboarding-accountform-btn\" expand=\"block\" [disabled]=\"form.invalid\" (click)=\"goContinue()\">\n        {{ 'ONBORDING.V2.BUTTON.NEXT' | wlpTranslate }}\n      </ui-c-button>\n    </ion-col>\n  </ion-row>\n</div>\n"
    })
], UiCAccountFormComponent);

let UiCAccountFormModule = class UiCAccountFormModule {
};
UiCAccountFormModule = __decorate([
    NgModule({
        declarations: [UiCAccountFormComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            NgxMaskIonicModule,
            IonicModule,
            UiBsTranslateModule,
            FormsModule,
            UiCButtonModule,
            UiCInputModule,
            UiCHeaderOnboardingModule
        ],
        exports: [UiCAccountFormComponent]
    })
], UiCAccountFormModule);

export { UiCAccountFormComponent, UiCAccountFormModule };
//# sourceMappingURL=wlp-ui-c-account-form.js.map
